import { render, staticRenderFns } from "./applications-table.vue?vue&type=template&id=0aff865e"
import script from "./applications-table.vue?vue&type=script&lang=js"
export * from "./applications-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports